import type { AdviserProfile, AdviserSharedVault } from '@syfo/types/adviser.types';
import type { VaultDocument } from '@syfo/types/vault.types';

export enum ShadeMode {
  Light = 'light',
  Dark = 'dark'
}

export interface AuthState {
  isAuthenticated: boolean | null; // null = loading, false = not authenticated, true = authenticated
  userProfile: AdviserProfile | null;
}

export interface ThemeState {
  mode: ShadeMode;
}

export interface FeedbackState {
  isOpen: boolean;
  isSending: boolean;
  lastSent: string | null;
  error: string | null;
}

export interface VaultsState {
  list: AdviserSharedVault[];
  isLoading: boolean;
  error: string | null;
  lastFetchedAt: string | null;
}

export interface VaultState {
  current: {
    shareId: string;
    vault: VaultDocument;
    metadata: {
      name: string;
      email: string;
      phone: string;
    };
  } | null;
  isLoading: boolean;
  error: string | null;
}